import React from "react";
import { FormattedMessage } from "react-intl";
import { type IVatRowData } from "./types";

type VatRowConfig = Pick<IVatRowData, "title" | "titleBmg" | "titleSt" | "isGroupTitle">;

const emptyLine: VatRowConfig = { title: <div>&nbsp;</div>, isGroupTitle: true };

export const defaultVatRowConfig: VatRowConfig[] = [
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupA" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableSales19" />
            </div>
        ),
        titleBmg: "81",
        titleSt: "X1",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableSales7" />
            </div>
        ),
        titleBmg: "86",
        titleSt: "X2",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableSales0" />
            </div>
        ),
        titleBmg: "87",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.otherTaxRates" />
            </div>
        ),
        titleBmg: "35",
        titleSt: "36",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.agriculturalWithVatId" />
            </div>
        ),
        titleBmg: "77",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.salesPara24" />
            </div>
        ),
        titleBmg: "76",
        titleSt: "80",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupB" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.intraCommunityDeliveriesWithVatId" />
            </div>
        ),
        titleBmg: "41",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.newVehiclesToBuyerWithoutVatId" />
            </div>
        ),
        titleBmg: "44",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.newVehiclesOutsideBusiness" />
            </div>
        ),
        titleBmg: "49",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.otherTaxFreeWithInputTax" />
            </div>
        ),
        titleBmg: "43",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxFreeWithoutInputTax" />
            </div>
        ),
        titleBmg: "48",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupC" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxFreeEuAcquisitions" />
            </div>
        ),
        titleBmg: "91",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableEuAcquisitions19" />
            </div>
        ),
        titleBmg: "89",
        titleSt: "X3",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableEuAcquisitions7" />
            </div>
        ),
        titleBmg: "93",
        titleSt: "X4",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableEuAcquisitions0" />
            </div>
        ),
        titleBmg: "90",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.otherTaxRates" />
            </div>
        ),
        titleBmg: "95",
        titleSt: "98",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.newVehiclesFromSuppliersWithoutVatId" />
            </div>
        ),
        titleBmg: "94",
        titleSt: "96",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupD" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.otherServicesPara3a" />
            </div>
        ),
        titleBmg: "46",
        titleSt: "47",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.salesUnderGrEStG" />
            </div>
        ),
        titleBmg: "73",
        titleSt: "74",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.otherServicesPara13b" />
            </div>
        ),
        titleBmg: "84",
        titleSt: "85",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupE" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.firstBuyerTriangularTransactions" />
            </div>
        ),
        titleBmg: "42",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxableSalesRecipientOwesTax" />
            </div>
        ),
        titleBmg: "60",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.nonTaxableOtherServicesPara18b" />
            </div>
        ),
        titleBmg: "21",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.otherNonTaxableSales" />
            </div>
        ),
        titleBmg: "45",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.dms.vat" />
            </strong>
        ),
        titleSt: "X5",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupF" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.inputTaxFromInvoices" />
            </div>
        ),
        titleSt: "66",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.inputTaxFromIntraCommunityAcquisition" />
            </div>
        ),
        titleSt: "61",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.importVat" />
            </div>
        ),
        titleSt: "62",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.inputTaxFromPara13b" />
            </div>
        ),
        titleSt: "67",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.inputTaxAverageRates" />
            </div>
        ),
        titleSt: "63",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.inputTaxNewVehiclesSmallBusiness" />
            </div>
        ),
        titleSt: "59",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.inputTaxCorrectionPara15a" />
            </div>
        ),
        titleSt: "64",
    },
    emptyLine,
    {
        title: (
            <b>
                <FormattedMessage id="app.ustva.inputTax" />
            </b>
        ),
        titleSt: "X6",
    },
    emptyLine,
    {
        title: (
            <b>
                <FormattedMessage id="app.ustva.remainingAmount" />
            </b>
        ),
        titleSt: "X7",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupG" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.taxFromChangeOfTaxationForm" />
            </div>
        ),
        titleSt: "65",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.incorrectlyShownTaxPara14c" />
            </div>
        ),
        titleSt: "69",
    },
    emptyLine,
    {
        title: (
            <b>
                <FormattedMessage id="app.ustva.groupH" />
            </b>
        ),
        titleSt: "X8",
    },
    emptyLine,
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.deductionSpecialPrepayment" />
            </div>
        ),
        titleSt: "39",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.remainingVatPrepayment" />
            </strong>
        ),
        titleSt: "83",
    },
    emptyLine,
    {
        title: (
            <strong>
                <FormattedMessage id="app.ustva.groupI" />
            </strong>
        ),
        isGroupTitle: true,
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.reductionOfTaxBase" />
            </div>
        ),
        titleBmg: "50",
    },
    {
        title: (
            <div>
                <FormattedMessage id="app.ustva.reductionOfDeductibleInputTax" />
            </div>
        ),
        titleSt: "37",
    },
];
